import { ContentWrapper } from '../../components/content_wrapper/content_wrapper';
import { debounce } from 'lodash';
import { getBrands } from '../../redux/reference_data';
import { getImgixPath } from '../../lib/imgix';
import { Input } from 'antd';
import { Link } from 'react-router-dom';
import { OmniaUrls } from '../../lib/urls';
import { ShopPanel } from './shop_panel';
import { useResponsive } from '../../hooks/use_responsive';
import { useSelector } from 'react-redux';
import React, { useState } from 'react';
import styles from './shop_page.less';

export const normalizeBrandsText = (text: string) => {
  return text
    .replace(/[\.\-]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
};

export const ShopPageBrands = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const brands = useSelector(getBrands);
  const { isMobile } = useResponsive();
  const featuredBrands = brands.filter((brand) => brand.featured);

  const searchQueryWithSpace = normalizeBrandsText(searchQuery);
  const searchQueryWithoutSpace = searchQueryWithSpace.replace(/\s/g, '');

  const debouncedSearch = debounce((value) => {
    setSearchQuery(normalizeBrandsText(value));
  }, 300);

  const filteredFeaturedBrands = featuredBrands.filter((brand) => {
    const normalizedBrandName = normalizeBrandsText(brand.display_name);
    return (
      normalizedBrandName.includes(searchQueryWithSpace) ||
      normalizedBrandName.includes(searchQueryWithoutSpace)
    );
  });

  const filteredBrands = brands.filter((brand) => {
    const normalizedBrandName = normalizeBrandsText(brand.display_name);
    return (
      normalizedBrandName.includes(searchQueryWithSpace) ||
      normalizedBrandName.includes(searchQueryWithoutSpace)
    );
  });

  return (
    <ContentWrapper mobileNoPadding>
      <section className={styles.shopSection}>
        <ShopPanel
          isMobile={isMobile}
          heading="Shop by Brand"
          className={styles.backgroundOmniaBlue}
        >
          <Input.Search
            placeholder="Search Brands"
            onChange={(e) => debouncedSearch(e.target.value)}
            style={{ marginBottom: 20 }}
            className={styles.search}
          />
          <ul className={styles.featuredList}>
            {filteredFeaturedBrands.map((brand) => (
              <li key={brand.name} className={styles.featuredItem}>
                <Link to={OmniaUrls.brand(brand)} className={styles.link}>
                  <img src={getImgixPath(brand.image, { w: 450 })} alt={brand.display_name} />
                </Link>
              </li>
            ))}
          </ul>
          <ul className={styles.shopList}>
            {filteredBrands.map((brand) => (
              <li key={brand.name}>
                <Link to={OmniaUrls.brand(brand)} className={styles.link}>
                  {brand.display_name}
                </Link>
              </li>
            ))}
          </ul>
        </ShopPanel>
      </section>
    </ContentWrapper>
  );
};
